module.exports = __webpack_public_path__ + "static/media/PENNY.cd1e6e06.svg";